<template>
	<section class="small-pad">
		<div class="container" v-html="content">
		</div>
	</section>
</template>
<script>
export default {
  name: 'Container',
  props: ['file'],
  data: () => ({
    content: ''
  }),
  watch: {
  	"$i18n.locale": function() {
  	  this.updateContent(this.file, this.$i18n.locale)
  	}
  },
  created: function() {
    this.updateContent(this.file, this.$i18n.locale)
  },
  methods: {
  	updateContent: function(file, lang) {
  	    //get content
	    let fn = file + '-' + lang + '.html',
	        that = this
	    this.$http.get(this.API_PREFIX + '/sources/' + fn).then(function (response) {
		  that.content = response.data
		}).catch(function (error) {
		  console.log(error)
		})
  	}
  }
}
</script>
